import styled from 'styled-components';

export const Head = styled.div`
  background-color: var(--background-color);
  width: 100%;
`;

export const Hero = styled.div`
  text-align: center;
  padding: 28px 20px 10px;
  background-color: var(--background-color);
`;

export const HeroTitle = styled.h1`
  font-size: clamp(18px, 2.5vw, 26px);
  font-weight: 800;
  color: var(--text-color);
  margin: 0 0 6px;
  line-height: 1.2;
  span { color: var(--text-color); }
`;

export const HeroSub = styled.p`
  font-size: clamp(12px, 1.4vw, 15px);
  color: var(--text-color);
  opacity: 0.5;
  margin: 0 0 4px;
  letter-spacing: 0.03em;
`;

export const HeroTags = styled.p`
  font-size: clamp(11px, 1.2vw, 13px);
  color: var(--accent-color);
  opacity: 0.7;
  margin: 0;
  letter-spacing: 0.05em;
  font-weight: 600;
`;

export const BuscadorRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  @media (max-width: 768px) { width: 100%; padding: 0 8px; box-sizing: border-box; }
`;

export const Body = styled.div`
  background-color: var(--background-color);
`;

export const PrincipalGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, var(--card-w, clamp(180px, 13vw, 280px)));
  justify-content: center;
  gap: 10px; /* Simplificado: une column-gap y row-gap */
  padding: 20px 0 80px 0;
  min-height: 85vh;
  background-color: var(--background-color);
  align-content: start;

  @media (max-width: 600px) {
    /* CAMBIO CLAVE: minmax(0, 1fr) obliga a que las 2 columnas midan el 50% exacto del móvil */
    grid-template-columns: repeat(2, minmax(0, 1fr)); 
    padding: 12px 8px 80px;
    gap: 8px; /* Simplificado para móvil */
  }
`;


export const ToggleBtn = styled.button`
  background: ${p => p.active ? 'var(--accent-color)' : 'transparent'};
  color: ${p => p.active ? '#fff' : 'var(--accent-color)'};
  border: 1px solid var(--accent-color);
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
  &:hover { background: ${p => p.active ? 'var(--accent-color)' : 'var(--accent-color)22'}; }
`;

export const ArticleCard = styled.div`
  width: var(--card-w, clamp(180px, 13vw, 280px));
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  background: var(--modal-bg-color, #1a1a2e);
  border: 2px solid rgb(247, 247, 251);
  transition: box-shadow 0.2s;
  &:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.35); }
  @media (max-width: 600px) { width: 100%; }
`;

export const ArticleImg = styled.img`
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  display: block;
`;

export const ArticleInfo = styled.div`
  padding: 6px 10px 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ArticlePrice = styled.div`
  font-size: 15px;
  font-weight: 800;
  color: var(--accent-color);
  line-height: 1.1;
`;

export const ArticleNombre = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: var(--text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ArticleTrastero = styled.div`
  font-size: 11px;
  color: var(--text-color);
  opacity: 0.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
